import React, { useEffect, useState } from "react";
import axios from "axios";
// import "./MonthlyReferPool.css";

const API_URL =
  "https://server.apnaone.com/leaderboard/monthly-referral";

const MonthlyReferPool = () => {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchMonthlyReferralLeaderboard = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(API_URL);

      console.log("Referral leaderboard response:", response?.data);

      if (response?.data?.status === true) {
        setLeaders(
          Array.isArray(response?.data?.data)
            ? response.data.data
            : []
        );
      } else {
        setLeaders([]);
        setError(
          response?.data?.msg || "Unable to load leaderboard"
        );
      }
    } catch (err) {
      console.error(
        "Monthly referral leaderboard error:",
        err
      );

      setLeaders([]);
      setError(
        err?.response?.data?.msg ||
          "Something went wrong while loading leaderboard"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMonthlyReferralLeaderboard();
  }, []);

  const getInitial = (name) => {
    if (!name || typeof name !== "string") {
      return "P";
    }

    return name.trim().charAt(0).toUpperCase() || "P";
  };

  const formatAmount = (amount) => {
    const value = Number(amount);

    if (Number.isNaN(value)) {
      return "0";
    }

    return value.toLocaleString("en-IN");
  };

  /*
   * IMPORTANT:
   * Image + fallback dono render kar rahe hain.
   * Isliye nextElementSibling null wala error nahi aayega.
   */
  const renderAvatar = (player, className = "") => {
    const avatar = player?.avatar;
    const name = player?.Name || "Player";

    return (
      <div className={`mrp-avatar-box ${className}`}>

        {avatar ? (
          <img
            src={avatar}
            alt={name}
            className="mrp-avatar"
            onError={(e) => {
              e.currentTarget.style.display = "none";

              const fallback =
                e.currentTarget.parentElement?.querySelector(
                  ".mrp-avatar-fallback"
                );

              if (fallback) {
                fallback.style.display = "flex";
              }
            }}
          />
        ) : null}

        <div
          className="mrp-avatar mrp-avatar-fallback"
          style={{
            display: avatar ? "none" : "flex",
          }}
        >
          {getInitial(name)}
        </div>

      </div>
    );
  };

  const topThree = Array.isArray(leaders)
    ? leaders.slice(0, 3)
    : [];

  const remainingPlayers = Array.isArray(leaders)
    ? leaders.slice(3)
    : [];

  /* ==========================================
     LOADING
  ========================================== */

  if (loading) {
    return (
      <section className="monthly-refer-pool">
        <div className="mrp-container">

          <div className="mrp-header">
            <div>
              <span className="mrp-small-title">
                REFERRAL CHAMPIONS
              </span>

              <h2>Monthly Referral Pool</h2>

              <p>
                Top referral earners of the month
              </p>
            </div>
          </div>

          <div className="mrp-loading-grid">
            {[1, 2, 3, 4, 5].map((item) => (
              <div
                className="mrp-skeleton-card"
                key={item}
              >
                <div className="mrp-skeleton mrp-skeleton-avatar" />

                <div className="mrp-skeleton mrp-skeleton-name" />

                <div className="mrp-skeleton mrp-skeleton-amount" />
              </div>
            ))}
          </div>

        </div>
      </section>
    );
  }

  return (
    <section className="monthly-refer-pool">
      <div className="mrp-container">

        {/* ==========================================
            HEADER
        ========================================== */}

        <div className="mrp-header">

          <div className="mrp-header-content">

            <span className="mrp-small-title">
              REFERRAL CHAMPIONS
            </span>

            <h2>
              Monthly Referral Pool
            </h2>

            <p>
              Top 10 players with the highest referral earnings
            </p>

          </div>

          <div className="mrp-period">
            <span className="mrp-calendar-icon">
              ◷
            </span>

            <span>
              Last 30 Days
            </span>
          </div>

        </div>


        {/* ==========================================
            ERROR
        ========================================== */}

        {error && (
          <div className="mrp-error">

            <div className="mrp-error-icon">
              !
            </div>

            <div className="mrp-error-content">
              <strong>
                Unable to load leaderboard
              </strong>

              <p>
                {error}
              </p>
            </div>

            <button
              type="button"
              onClick={fetchMonthlyReferralLeaderboard}
            >
              Retry
            </button>

          </div>
        )}


        {/* ==========================================
            EMPTY
        ========================================== */}

        {!error && leaders.length === 0 && (
          <div className="mrp-empty">

            <div className="mrp-empty-icon">
              🏆
            </div>

            <h3>
              No Referral Data Yet
            </h3>

            <p>
              Referral leaderboard will appear here once
              players start earning referral rewards.
            </p>

          </div>
        )}


        {/* ==========================================
            PODIUM
        ========================================== */}

        {!error && topThree.length > 0 && (
          <div className="mrp-podium">

            {/* SECOND */}

            {topThree[1] && (
              <div className="mrp-podium-item mrp-second">

                <div className="mrp-rank-badge">
                  2
                </div>

                <div className="mrp-podium-avatar-wrap">
                  {renderAvatar(topThree[1])}
                </div>

                <h3>
                  {topThree[1]?.Name || "Player"}
                </h3>

                <div className="mrp-earning">
                  ₹
                  {formatAmount(
                    topThree[1]?.referralEarning
                  )}
                </div>

                <span className="mrp-earning-label">
                  Referral Earnings
                </span>

                <div className="mrp-podium-base">
                  <span>02</span>
                </div>

              </div>
            )}


            {/* FIRST */}

            {topThree[0] && (
              <div className="mrp-podium-item mrp-first">

                <div className="mrp-crown">
                  ♛
                </div>

                <div className="mrp-rank-badge">
                  1
                </div>

                <div className="mrp-podium-avatar-wrap">
                  {renderAvatar(topThree[0])}
                </div>

                <h3>
                  {topThree[0]?.Name || "Player"}
                </h3>

                <div className="mrp-earning">
                  ₹
                  {formatAmount(
                    topThree[0]?.referralEarning
                  )}
                </div>

                <span className="mrp-earning-label">
                  Referral Earnings
                </span>

                <div className="mrp-podium-base">
                  <span>01</span>
                </div>

              </div>
            )}


            {/* THIRD */}

            {topThree[2] && (
              <div className="mrp-podium-item mrp-third">

                <div className="mrp-rank-badge">
                  3
                </div>

                <div className="mrp-podium-avatar-wrap">
                  {renderAvatar(topThree[2])}
                </div>

                <h3>
                  {topThree[2]?.Name || "Player"}
                </h3>

                <div className="mrp-earning">
                  ₹
                  {formatAmount(
                    topThree[2]?.referralEarning
                  )}
                </div>

                <span className="mrp-earning-label">
                  Referral Earnings
                </span>

                <div className="mrp-podium-base">
                  <span>03</span>
                </div>

              </div>
            )}

          </div>
        )}


        {/* ==========================================
            OTHER TOP 10
        ========================================== */}

        {!error && remainingPlayers.length > 0 && (
          <div className="mrp-list-section">

            <div className="mrp-list-header">

              <div>
                <h3>
                  Top Referral Earners
                </h3>

                <p>
                  Other top performing referral partners
                </p>
              </div>

              <span>
                TOP 10
              </span>

            </div>


            <div className="mrp-list">

              {remainingPlayers.map(
                (player, index) => (

                  <div
                    className="mrp-player-row"
                    key={
                      player?.userId ||
                      `player-${index}`
                    }
                  >

                    <div className="mrp-left">

                      <div className="mrp-list-rank">
                        {player?.rank || index + 4}
                      </div>

                      <div className="mrp-list-avatar">
                        {renderAvatar(player)}
                      </div>

                      <div className="mrp-player-info">

                        <h4>
                          {player?.Name || "Player"}
                        </h4>

                        <span>
                          Referral Champion
                        </span>

                      </div>

                    </div>


                    <div className="mrp-right">

                      <span className="mrp-earned-text">
                        EARNED
                      </span>

                      <strong>
                        ₹
                        {formatAmount(
                          player?.referralEarning
                        )}
                      </strong>

                    </div>

                  </div>

                )
              )}

            </div>

          </div>
        )}


        {/* ==========================================
            FOOTER
        ========================================== */}

        {!error && leaders.length > 0 && (
          <div className="mrp-footer">

            <span>
              🏆
            </span>

            <p>
              Keep referring and climb the leaderboard!
            </p>

          </div>
        )}

      </div>
    </section>
  );
};

export default MonthlyReferPool;